import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import { WhiteLayout, SectionHeadLayout } from "netcompany-mdx-slide";
import programmingParadigms from "./assets/programming_paradigms.png";
import program_paradigms from "./assets/program_paradigms.png";
import imperative_approach from "./assets/imperative_approach.png";
import functional_approach from "./assets/functional_approach.png";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SectionHeadLayout title={"Programming paradigms"} backgroundImage={programmingParadigms} mdxType="SectionHeadLayout" />
    <hr></hr>
    <WhiteLayout title={"Programming paradigms"} mdxType="WhiteLayout">
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Is a way/style/approach of programming in order to solve a given problem`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`There are two groups of programming paradigm:`}</p>
        </li>
      </ul>
      <div style={{
        display: "flex",
        width: "65%",
        flexDirection: "column",
        alignSelf: "center"
      }}>
  <img src={program_paradigms} style={{
          objectFit: 'contain'
        }} alt="program_paradigms" />
      </div>
    </WhiteLayout>
    <hr></hr>
    <WhiteLayout title={"Programming paradigms"} mdxType="WhiteLayout">
      <p>{`Two groups:`}</p>
      <ul>
        <li parentName="ul">
          <p parentName="li">{`Imperative: how to achieve the goal, step by step, focus on the flow`}</p>
        </li>
        <li parentName="ul">
          <p parentName="li">{`Declarative: what to achieve, focus on the desired result.`}</p>
        </li>
      </ul>
      <div style={{
        display: "flex",
        flex: 1,
        flexDirection: "row"
      }}>
  <img src={imperative_approach} style={{
          objectFit: 'contain'
        }} alt="imperative_approach" />
  <img src={functional_approach} style={{
          objectFit: 'contain'
        }} alt="functional_approach" />
      </div>
    </WhiteLayout>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      